const LANG_KEY = "axoris.lang";
const THEME_KEY = "axoris.theme";

const param = (name) => new URLSearchParams(window.location.search).get(name);

export function resolveLang() {
  const q = param("lang");
  if (q === "id" || q === "en") localStorage.setItem(LANG_KEY, q);
  const saved = localStorage.getItem(LANG_KEY);
  return saved === "en" ? "en" : "id";
}

export function resolveTheme() {
  const q = param("theme");
  if (q === "light" || q === "dark" || q === "system") localStorage.setItem(THEME_KEY, q);
  const saved = localStorage.getItem(THEME_KEY) || "system";
  if (saved === "system") {
    return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
  }
  return saved;
}

export function applyPrefs() {
  document.documentElement.setAttribute("data-theme", resolveTheme());
  document.documentElement.setAttribute("lang", resolveLang());
  window
    .matchMedia("(prefers-color-scheme: dark)")
    .addEventListener("change", () => {
      if ((localStorage.getItem(THEME_KEY) || "system") === "system") {
        document.documentElement.setAttribute("data-theme", resolveTheme());
      }
    });
}

export function getSidebarCollapsed() {
  return localStorage.getItem("axoris.sidebar") === "collapsed";
}
export function setSidebarCollapsed(v) {
  localStorage.setItem("axoris.sidebar", v ? "collapsed" : "open");
}

export const getThemePref = () => localStorage.getItem(THEME_KEY) || "system";
export function setThemePref(mode) {
  if (!["light", "dark", "system"].includes(mode)) return false;
  localStorage.setItem(THEME_KEY, mode);
  const url = new URL(window.location.href);
  url.searchParams.set("theme", mode);
  window.history.replaceState(window.history.state, "", url);
  document.documentElement.setAttribute("data-theme", resolveTheme());
  return true;
}
export function setLangPref(lang) {
  if (lang !== "id" && lang !== "en") return false;
  localStorage.setItem(LANG_KEY, lang);
  document.documentElement.setAttribute("lang", lang);
  const url = new URL(window.location.href);
  url.searchParams.set("lang", lang);
  window.history.replaceState(window.history.state, "", url);
  window.dispatchEvent(new PopStateEvent("popstate", { state: window.history.state }));
  return true;
}
